module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crud-action"
  }, [_c('ul', {
    staticClass: " right"
  }, [(!_vm.exclude.includes('duplicate')) ? _c('li', {
    staticClass: "content-item edit"
  }, [_c('div', {
    staticClass: "value-action-duplicate"
  }, [_c('i', {
    staticClass: "icon yule-icon-duplicate",
    on: {
      "click": _vm.duplicate
    }
  }), _vm._v(" "), _c('q-tooltip', [_vm._v(" " + _vm._s(_vm.$t('models.duplicate_action')) + " ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "value-action-pending"
  }, [_c('i', {
    staticClass: "icon yule-icon-clock",
    attrs: {
      "title": _vm.$t('models.external_form.pending_cloning')
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.exclude.includes('edit')) ? _c('li', {
    staticClass: "content-item edit"
  }, [_c('router-link', {
    staticClass: "icon yule-icon-edit",
    attrs: {
      "to": _vm.editRouteParams,
      "data-action": _vm.model + '.edit',
      "data-action-id": _vm.item.id
    },
    nativeOn: {
      "click": function($event) {
        return _vm.outsideClick($event)
      }
    }
  }, [_c('q-tooltip', [_vm._v(" " + _vm._s(_vm.$t('models.edit_action')) + " ")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.exclude.includes('delete')) ? _c('li', {
    staticClass: "content-item"
  }, [_c('modal', {
    attrs: {
      "title": _vm.$t('ui.global.delete_title'),
      "content": _vm.$t('ui.global.delete_confirmation', {
        name: _vm.item.name
      }),
      "actions": [{
          name: 'valid',
          class: 'btn btn-cancel',
          action: _vm.model + '.delete.confirm'
        },
        {
          name: 'cancel',
          class: 'btn btn-tertiary',
          action: _vm.model + '.delete.cancel'
        }
      ],
      "btn-class": " ",
      "data-action": _vm.model + '.delete',
      "data-action-id": _vm.item.id
    },
    on: {
      "action": _vm.action
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-trash"
  }, [_c('q-tooltip', [_vm._v(" " + _vm._s(_vm.$t('models.delete_action')) + " ")])], 1)])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45eb7706","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueCrudActionFolded.vue
// module id = 1888
// module chunks = 0